import ListVacancyCandidates from './ListVacancyCandidates';

export default ListVacancyCandidates;
